module.exports = __webpack_public_path__ + "static/media/kdb-banner-3@2x.6967c352.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kdb-banner-3@2x.png
// module id = 1278
// module chunks = 1